import { render, staticRenderFns } from "./previewWap.vue?vue&type=template&id=01c5fe86&scoped=true&"
import script from "./previewWap.vue?vue&type=script&lang=js&"
export * from "./previewWap.vue?vue&type=script&lang=js&"
import style0 from "./previewWap.vue?vue&type=style&index=0&id=01c5fe86&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01c5fe86",
  null
  
)

export default component.exports